import { IArticleViewModel } from 'Types/Litium';
import BlockRenderer from 'Blocks/BlockRenderer';
import BreadCrumbs from 'Components/BreadCrumbs';
import Markup from 'Components/Markup';
import ImageStripe from 'Components/PageElements/ImageStripe';
import NavigationMenu from 'Components/PageElements/NavigationMenu';

const ArticlePage = ({
    blockAreas,
    breadCrumbs,
    title,
    titleTextColor,
    text,
    pageImageStripe,
    pageBackgroundImage,
    hideBreadcrumbs,
    hideSecondLevelNavigationMenu,
    linksHeader,
    images,
    links,
    subNavigation,
}: IArticleViewModel) => {
    const isContentFullWidth =
        typeof hideSecondLevelNavigationMenu === 'undefined';
    return (
        <div
            style={{
                backgroundImage:
                    pageBackgroundImage?.src &&
                    `url(${pageBackgroundImage.src}?format=webp)`,
            }}
            className="grid h-full w-full bg-cover bg-center bg-no-repeat"
        >
            <ImageStripe imageStripe={pageImageStripe} />

            {blockAreas?.above && <BlockRenderer blocks={blockAreas.above} />}

            {!hideBreadcrumbs && breadCrumbs?.contentLinks && (
                <BreadCrumbs
                    contentLinks={breadCrumbs.contentLinks}
                    margin="mt-2 lg:mt-4 lg:mb-3"
                    backgroundColor="bg-none"
                />
            )}

            <div className="mx-auto grid w-full max-w-content px-3 pb-4 lg:grid-cols-12 lg:gap-6 lg:px-14">
                {!hideSecondLevelNavigationMenu && subNavigation?.links && (
                    <div className="hidden lg:col-span-2 lg:block">
                        <NavigationMenu subNavigation={subNavigation.links} />
                    </div>
                )}
                {isContentFullWidth ? (
                    <section className="lg:col-span-12">
                        <Markup
                            html={text.value}
                            as="article"
                            cssClass="prose-block max-w-none"
                        />
                    </section>
                ) : (
                    <section
                        className={
                            hideSecondLevelNavigationMenu
                                ? 'lg:col-span-9'
                                : 'lg:col-span-8'
                        }
                    >
                        {title && (
                            <h1
                                style={{
                                    color:
                                        titleTextColor && `${titleTextColor}`,
                                }}
                                className="font-montserrat text-h1 leading-normal"
                            >
                                {title}
                            </h1>
                        )}
                        <Markup
                            html={text.value}
                            as="article"
                            cssClass="prose-block max-w-none"
                        />
                    </section>
                )}
                <div
                    className={`flex flex-col justify-start align-top lg:justify-start ${
                        hideSecondLevelNavigationMenu
                            ? 'lg:col-span-3'
                            : 'lg:col-span-2'
                    }`}
                >
                    <figure className="mb-5">
                        {images?.map((image, index) => (
                            <img
                                key={index}
                                src={image.src}
                                alt={image.altText}
                                width={image.width > 0 ? image.width : ''}
                                height={image.height > 0 ? image.height : ''}
                            />
                        ))}
                    </figure>
                    {links && (
                        <div className="flex flex-col">
                            <NavigationMenu
                                links={links}
                                linksHeader={linksHeader}
                            />
                        </div>
                    )}
                </div>
            </div>
            {blockAreas?.below && <BlockRenderer blocks={blockAreas.below} />}
        </div>
    );
};

export default ArticlePage;
